
import store from '@/store';
import Vue from 'vue'
import { UserDto } from '@chainsight/networker-backend-axios-sdk';

export default Vue.extend({
	name: 'Pricing',
	data() {
		return {
			overlay: false,
			isKeywordAnalyzing: false,
			progressValue: 0,
			progressStatusText: '',
			interval: null as any,
			userDto: {} as UserDto,
		};
	},
	computed: {
		user() {
			return store.state.user;
		},
		trackDto() {
			return store.state.track.trackDto;
		},
	},
	methods: {
		async getMe() {
			try{
				const getMeResp = await this.api$.authApi.getMe()
				if (getMeResp.data.data) {
					this.userDto = getMeResp.data.data
				}
			}catch (error) {
				console.error(error)
			}
		},
		goToProfile() {
			this.$router.push('/profile')
		}
	},
	async created() {
		this.overlay = true
		await Promise.all([
			this.getMe()
		])
		this.overlay = false
	},
	mounted() {
		// 監聽搜尋事件
		this.eventHub$.$on('searchStarted', () => {
			this.isKeywordAnalyzing = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
			
			// 啟動進度條動畫 - 15秒分成4等份
			let timer = 0
			this.interval = setInterval(() => {
				timer += 0.1  // 每100ms增加0.1秒
				
				// 確保不超過15秒
				if (timer > 15) {
					timer = 15
				}
				
				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)
		})

		this.eventHub$.$on('searchFinished', () => {
			// 完成動畫
			this.progressValue = 100
			clearInterval(this.interval)
			setTimeout(() => {
				this.isKeywordAnalyzing = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		})
	},
	beforeDestroy() {
		// 清理事件監聽器
		this.eventHub$.$off('searchStarted')
		this.eventHub$.$off('searchFinished')
		if (this.interval) {
			clearInterval(this.interval)
		}
	}
});
